import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./step.module.scss";

function Step(props) {
  const {id, title, description} = props;
  return (
    <section className={classNames(styles.root, styles[id])}>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>{description}</p>
    </section>
  );
}

Step.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string
};

export default Step;
